Vendd.Scripts.load(function () {

    initMainMenu();
    if (isTouch()) {
        toggleMobileMenuSecondLevel();
        toggleMobileMenuThirdLevel();
    }
});

function initMainMenu() {

    var $wrapper = $('.header-region .main-menu');

    var $firstLevel = $('.nav-1 > li > a', $wrapper);

    if (!isTouch()) {
        initMainMenuEffects($firstLevel);
        $(".main-menu").on("mouseleave", function (e) {
            $('.nav-1 > li',$wrapper).removeClass('hovered');
            $('.site-overlay').removeClass('visible');
        });
    } else {
        $('.main-menu .nav-1 > li.hasChildren >.title').click(function (e) {
            if ($(window).width() > 959) {
                e.preventDefault();
                var $el = $(this).parent();
                $el.siblings(".hovered").removeClass('hovered');
                $el.addClass('hovered').siblings('.hovered').removeClass('hovered');

                if ($el.hasClass('hasChildren')) {
                    $('.site-overlay').addClass('visible');
                }
                else {
                    $('.site-overlay').removeClass('visible');
                }
            }
        });
        $(window).resize(function () {
            if ($(window).width() < 960) {
                $('.site-overlay').removeClass('visible');
            }
        });
    }  
}

function initMainMenuEffects($submenus) {

    if ($submenus.length == 0)
        return;

    var config = {
        sensitivity: 10,
        interval: 80,
        over: mouseenter,
        timeout: 200,
        out: mouseleave
    };


    function mouseenter() {
        var $el = $(this);
        $el.siblings(".hovered").removeClass('hovered');
        $el.addClass('hovered').siblings('.hovered').removeClass('hovered');

        if ($el.hasClass('hasChildren')) {
            $('.site-overlay').addClass('visible');
        }
        else {
            $('.site-overlay').removeClass('visible');
        }
    }

    function mouseleave() {
        return;
    }

    $submenus.parent().hoverIntent(config);
}

function toggleMobileMenuSecondLevel() {
    $('.main-menu').on('click', '.js-toggle', function (e) {
        var $this = $(this);

        $this.parent().removeClass('hovered').siblings().removeClass('hovered');
        $this.parent().siblings().children('.js-toggle').children('.text').removeClass('icon-arrow-up').addClass('icon-arrow-down');
        $this.children('.text').toggleClass('icon-arrow-down icon-arrow-up');
        $this.parent().siblings().children('.submenu-wrapper').removeClass('opened');
        
        $this.siblings('.submenu-wrapper').toggleClass('opened active');
        $this.parent().toggleClass('parent-opened');

        if ($this.siblings('.submenu-wrapper').hasClass('opened')) {
            $('.off-canvas-menu').animate({ scrollTop: $this.closest('.nav-1 li').offset().top + $('.off-canvas-menu').scrollTop() }, 1);
        }

    });
}

function toggleMobileMenuThirdLevel() {
    $('.main-menu').on('click', '.js-toggle-third', function (e) {
        var $this = $(this);

        $this.parent().siblings().children('.js-toggle-third').children('.text').removeClass('icon-arrow-up').addClass('icon-arrow-down');
        $this.children('.text').toggleClass('icon-arrow-down icon-arrow-up');
        $this.parent().siblings().children('.nav-3').removeClass('opened');
        $this.siblings('.nav-3').toggleClass('opened');

        if ($this.siblings('.nav-3').hasClass('opened')) {
            $('.off-canvas-menu').animate({ scrollTop: $this.closest('.nav-2 li').offset().top + $('.off-canvas-menu').scrollTop() }, 1);
        }

    });
}